import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import SolidButton from '../../../../../Buttons/SolidButton';
const DestructiveConfirmButton = (_param)=>/*#__PURE__*/ {
    var { children } = _param, rest = _object_without_properties(_param, [
        "children"
    ]);
    return React.createElement(SolidButton, _object_spread({
        size: "large",
        variant: "destructive-red"
    }, rest), children);
};
DestructiveConfirmButton.displayName = 'DestructiveConfirmButton';
export default DestructiveConfirmButton;
